"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.createTable(_globals.MetaTable.COL_BUTTON, (table)=>{
        table.string('id', 20);
        table.string('base_id', 20);
        table.string('type');
        table.text('label');
        table.string('theme');
        table.string('color');
        table.string('icon');
        table.text('formula');
        table.text('formula_raw');
        table.string('error');
        table.text('parsed_tree');
        table.string('fk_webhook_id', 20);
        table.string('fk_column_id', 20);
        table.timestamps(true, true);
    });
};
const down = async (knex)=>{
    await knex.schema.dropTable(_globals.MetaTable.COL_BUTTON);
};
